import { DeviceFamily, Placement, PageType } from '@amzn/fire-tv-campaign-automation-service';
import { STAGE, ProvisionedConstants } from 'src/constants';

import { mergeConfig } from '../utils/ConfigUtils';

export type PageTypeConfig = Record<DeviceFamily, Partial<Record<Placement, PageType[]>>>;

const DEFAULT_CONFIG: PageTypeConfig = {
  [DeviceFamily.FIRE_TV]: {
    [Placement.FEATURE_ROTATOR]: [PageType.FTV_BROWSE, PageType.FTV_ROTATOR],
    [Placement.SCREEN_SAVER]: [PageType.FTV_BROWSE],
  },
  [DeviceFamily.FIRE_TABLETS]: {
    [Placement.FEATURE_ROTATOR]: [PageType.MOBILE_APPLICATION_STORE],
  },
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<PageTypeConfig>>> = {
  [STAGE.PROD_NA]: {
    [DeviceFamily.FIRE_TV]: {
      [Placement.FEATURE_ROTATOR]: [PageType.FTV_BROWSE, PageType.FTV_ROTATOR],
      [Placement.SCREEN_SAVER]: [PageType.FTV_BROWSE],
    },
  },
  [STAGE.PROD_FE]: {
    [DeviceFamily.FIRE_TV]: {
      [Placement.FEATURE_ROTATOR]: [PageType.FTV_BROWSE],
      [Placement.SCREEN_SAVER]: [PageType.FTV_BROWSE],
    },
  },
};

const stage = process.env.NODE_ENV === 'test' ? STAGE.DEV : ProvisionedConstants.STAGE;

export const PAGE_TYPE_CONFIG: PageTypeConfig = mergeConfig(
  DEFAULT_CONFIG,
  STAGE_OVERRIDES[stage as STAGE],
);
